import { ValidationErrors, oneError } from "./validationAllFields";

export function validateResponse(response, errors, is200Error = false) {
  if (response.status == 204) {
    return;
  } else if (response.status >= 200 && response.status <= 299 && !is200Error) {
    return response
      .json()
      .then(data => {
        return data;
      })
      .catch(error => {
        console.error(error);
      });
  } else if (
    response.status >= 400 && response.status <= 499 ||
      response.status >= 200 && response.status <= 299 && is200Error
  ) {
    return response.json().then(data => {
      let error = "";
      if (data.errors !== undefined) {
        error = data.errors.error;
      } else if (data.error != undefined) {
        error = data.error;
        if (data.fields != undefined && data.fields.error) {
          error = data.fields.error;
        }
      } else if (data.fields != undefined && data.fields.error) {
        error = data.fields.error;
      } else {
        if (!is200Error) {
          if (response.status == 403) {
            let err = oneError(
              "Użytkownik nie posiada uprawnień do wykonania tej akcji",
              "all"
            );
            throw new ValidationErrors(err);
          } else {
            let err = oneError("Nieznany błąd", "all");
            throw new ValidationErrors(err);
          }
        }
      }

      if (errors[error] != undefined) {
        let err = null;
        if (!Array.isArray(errors[error])) {
          err = oneError(
            errors[error].msg,
            errors[error].field,
            errors[error].show || true
          );
        } else {
          for (let i = 0; i < errors[error].length; i++) {
            if (err === null) {
              err = oneError(
                errors[error][i].msg,
                errors[error][i].field,
                errors[error].show || true
              );
            } else {
              err = oneError(
                errors[error][i].msg,
                errors[error][i].field,
                errors[error].show || true,
                err
              );
            }
          }
        }

        throw new ValidationErrors(err);
      } else {
        if (!is200Error) {
          if (response.status == 403) {
            let err = oneError(
              "Użytkownik nie posiada uprawnień do wykonania tej akcji",
              "all"
            );
            throw new ValidationErrors(err);
          } else {
            let err = oneError("Nieznany błąd", "all");
            throw new ValidationErrors(err);
          }
        } else {
          return data;
        }
      }
    });
  } else {
    let err = oneError(
      "Błąd serwera! Spróbuj ponownie za kilka minut. Jeśli błąd będzie się powtarzał skontaktuj się z administratorem",
      "all"
    );
    throw new ValidationErrors(err);
  }
  return false;
}

export function checkResponseError(error) {
  if (!(error instanceof ValidationErrors)) {
    let err = oneError("Problem z połączeniem, spróbuj ponownie", "all");
    return new ValidationErrors(err);
  }
  return error;
}



// WEBPACK FOOTER //
// ./src/common/lib/validateResponse.js